import React, { useEffect, useState } from "react";
import { PageHeader, Toast } from "@/components/Layout";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { lock } from "@/lib/perm";
import ViewOnly from "@/components/ViewOnly";

export default function EducationLevels() {
  const { has } = useAuth();
  const [cfg, setCfg] = useState(null);
  const [msg, setMsg] = useState({ text: "", type: "info" });

  useEffect(() => { api.get("/config").then(r => setCfg(r.data)); }, []);

  const save = async () => {
    try {
      await api.put("/config", cfg);
      setMsg({ text: "Salvat", type: "success" }); setTimeout(()=>setMsg({text:""}),1500);
    } catch(e) { setMsg({ text: e?.response?.data?.detail || "Eroare", type: "error" }); }
  };
  if (!cfg) return <div>Se încarcă...</div>;

  const upd = (i,v) => { const a = [...(cfg.education_levels||[])]; a[i] = v; setCfg({...cfg, education_levels: a}); };
  const add = () => setCfg({...cfg, education_levels: [...(cfg.education_levels||[]), "Nivel nou"]});
  const rm = (i) => { const a = [...(cfg.education_levels||[])]; a.splice(i,1); setCfg({...cfg, education_levels: a}); };

  return (
    <>
      <PageHeader title="Niveluri de studii" subtitle="Folosite la Rapoarte de muncă și Stat de funcții"
        actions={<button className="btn btn-primary" onClick={save} data-testid="save-education-levels" {...lock(has("config.update"))}>Salvează</button>} />
      <Toast msg={msg.text} type={msg.type} />
      <div className="card" style={{ padding: 24 }}>
        <ViewOnly on={!has("config.update")}>
        <div style={{display:"grid",gap:8}}>
          {(cfg.education_levels||[]).map((c,i)=>(
            <div key={i} style={{display:"flex",gap:8}}>
              <input className="input" value={c} onChange={e=>upd(i,e.target.value)} />
              <button className="btn btn-danger" style={{padding:"4px 10px",fontSize:12}} onClick={()=>rm(i)}>Șterge</button>
            </div>
          ))}
          <button className="btn btn-secondary" onClick={add}>+ Adaugă nivel</button>
        </div>
        </ViewOnly>
      </div>
    </>
  );
}
